import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.developers', {
        url: '/developers',
        component: 'companySaaspassConnectManageDevelopers',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/developers/developers.state.js